import { useQuery } from "@tanstack/react-query";
import {
  type EntityListOfSocialUserSummary,
  getSocialMutuals,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { SOCIAL_LIST_PAGE_SIZE } from "Pages/People/constants";
import { MS_TIME } from "Utils/TimeUtils";

export const mutualFollowersKeys = {
  all: ["SOCIAL_MUTUALS"] as const,
  page: (pageNumber: number) =>
    [...mutualFollowersKeys.all, pageNumber] as const,
};

/**
 * A page of the caller's mutual followers — Customers who follow the caller back (inactive
 * counterparties are dropped server-side, before paging and TotalCount). The first page also
 * feeds the new-conversation suggestions, so it stays fresh for a minute rather than refetching
 * on every dialog open; every graph mutation invalidates it anyway.
 */
export const useMutualFollowersQuery = (pageNumber = 1) =>
  useQuery<EntityListOfSocialUserSummary>({
    queryKey: mutualFollowersKeys.page(pageNumber),
    queryFn: processResponseWithApiProblemDetails(() =>
      getSocialMutuals(SOCIAL_LIST_PAGE_SIZE, pageNumber),
    ),
    staleTime: MS_TIME.minute,
  });
